import React from 'react';
import p1 from '../../assets/revs/p001.webp';
import p2 from '../../assets/revs/p002.webp';
import p3 from '../../assets/revs/p003.webp';

const About = () => {
  return (
    <section id='about'>
      <div className='container'>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>
          Почніть заробляти після дев'яти занять
        </h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          Після завершення курсів ми допоможемо вам зі стартом!
        </h4>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <div className='row'>
            <div className='col-lg-7'>
              <div className='card-review first bg-white flex aifs p-4'>
                <img src={p1} alt='Наталя' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Наталя, паспортистка</h4>
                  <p style={{ minHeight: 40, paddingTop: 7 }}>
                    Привіт! 
                    Пройшла курси GoIT за напрямком "Backend" і нічого не зрозуміла.
                    Потім пройшла курс вайб-кодінгу і все одно нічого не зрозуміла,
                    але мій код став працювати. Дякую вам за можливість, яку надали мені!
                  </p>
                </div>
              </div>
              <div className='s-24'></div>
              <div className='card-review second bg-white flex aifs p-4'>
                <img src={p2} alt='Сніжана' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Сніжана, кухарка</h4>
                  <p>
                    Велике дякую) я більше року не могла знайти роботу після технікуму, а тут
                    перевчилася на DevOps і через півтора місяці знайшла роботу! Це був дуже класний досвід) дякую за все і бажаю успіхів іншим учням!
                  </p>
                </div>
              </div>
              <div className='s-24 d-none-d-sm-block'></div>
            </div>
            <div className='col-lg-5'>
              <div className='card-review third bg-white flex aifs p-4'>
                <img src={p3} alt='Юрій' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Юрій, зварювальник</h4>
                  <div className='s-10'></div>
                  <p style={{ paddingRight: 18 }}>
                    Ось це ті самі курси, які я шукав!
                    Всі інші - складні, парять мозок і я нічого не розумію.
                    А тут все просто і зрозуміло. Навчився робити сайти на Next.js як пиріжки!
                    Звісно, вони не такі гарні, як очікують замовники, але зате працюють.
                    А головне, що я можу їх робити за допомогою ШІ дуже швидко!
                    <br />
                    Моя порада майбутнім учням: не йдіть працювати за наймом, а одразу починайте дзвонити в агентства
                    і пропонувати свої послуги. Погоджуйтесь на будь-які умови, головне - отримати аванс. Там вони вже
                    нікуди не подінуться! Перевірено на собі.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
      </div>
    </section>
  );
};

export { About }; 